var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React from 'react';
import { action, observable } from 'mobx';
import { observer } from 'mobx-react';
import styles from './ProjectReaders.module.scss';
import { Api } from '@app/Api';
import { Button } from '@app/Components/Button/Button';
import { FaTrash } from 'react-icons/fa';
import { Grid } from '@app/Components/Grid/Grid';
import { Column } from 'devextreme-react/data-grid';
import { AddProjectReaders } from './AddProjectReaders/AddProjectReaders';
export var ProjectReaders = /** @class */ (function (_super) {
    __extends(ProjectReaders, _super);
    function ProjectReaders() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._projectReaders = [];
        _this._loading = false;
        return _this;
    }
    ProjectReaders.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this._loadProjectReaders()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    ProjectReaders.prototype._loadProjectReaders = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this._loading = true;
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, , 3, 4]);
                        _a = this;
                        return [4 /*yield*/, Api.secured.getProjectReaders({ projectId: this.props.projectId })];
                    case 2:
                        _a._projectReaders = _b.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        this._loading = false;
                        return [7 /*endfinally*/];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    ProjectReaders.prototype._handleProjectReaderDelete = function (principalId) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, Api.secured.deleteProjectReader({ projectId: this.props.projectId, principalId: principalId })];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this._loadProjectReaders()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    ProjectReaders.prototype._handleProjectReaderSave = function (users) {
        return __awaiter(this, void 0, void 0, function () {
            var projectReaders, promse;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(users && users.length > 0)) return [3 /*break*/, 3];
                        projectReaders = users.map(function (user) { return ({
                            projectId: _this.props.projectId,
                            principalId: user.id
                        }); });
                        promse = Api.secured.createProjectReaders({ body: projectReaders });
                        return [4 /*yield*/, promse];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this._loadProjectReaders()];
                    case 2: return [2 /*return*/, _a.sent()];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    ProjectReaders.prototype.render = function () {
        var _a;
        var _this = this;
        var projectId = (_a = this.props, _a.projectId), editable = _a.editable;
        return (React.createElement("div", { className: styles.wrapper },
            React.createElement("div", { className: styles.table },
                React.createElement(Grid, { dataSource: this._projectReaders, loading: this._loading },
                    React.createElement(Column, { caption: "Code", dataField: "principalCode", width: 200 }),
                    React.createElement(Column, { caption: "Name", dataField: "principalDisplayName", width: 250 }),
                    React.createElement(Column, { caption: "Assigned To", dataField: "assignToNames", width: 250 }),
                    React.createElement(Column, { caption: "Functions", dataField: "functionsCodes", width: 250 }),
                    React.createElement(Column, { caption: "Is Project Member", dataField: "isProjectMember", width: 130, calculateCellValue: function (value) { return (value.isProjectMember ? 'Yes' : 'No'); } }),
                    editable && (React.createElement(Column, { caption: "Actions", minWidth: 50, cellRender: function (_a) {
                            var data = _a.data;
                            return !data.isSystem && (React.createElement("div", { className: styles.actions },
                                React.createElement(Button, { className: styles.action, color: "danger", size: "xs", onClick: function () { return _this._handleProjectReaderDelete(data.principalId); }, disabled: !(!data.functionsCodes && data.canPrincipalManipulateWithReader) },
                                    React.createElement(FaTrash, null))));
                        } })))),
            editable && React.createElement(AddProjectReaders, { projectId: projectId, onSave: this._handleProjectReaderSave })));
    };
    __decorate([
        observable
    ], ProjectReaders.prototype, "_projectReaders", void 0);
    __decorate([
        observable
    ], ProjectReaders.prototype, "_loading", void 0);
    __decorate([
        action.bound
    ], ProjectReaders.prototype, "_loadProjectReaders", null);
    __decorate([
        action.bound
    ], ProjectReaders.prototype, "_handleProjectReaderDelete", null);
    __decorate([
        action.bound
    ], ProjectReaders.prototype, "_handleProjectReaderSave", null);
    ProjectReaders = __decorate([
        observer
    ], ProjectReaders);
    return ProjectReaders;
}(React.PureComponent));
